import { HTMLAttributes } from "react"

import { Translate } from "../translate"
import { BaseTypographyProps } from "./types"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type SpanSpanrops = BaseTypographyProps & HTMLAttributes<HTMLSpanElement>

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const Span = ({ i18nKey, values, formats, ...props }: SpanSpanrops) => {
  return (
    <span {...props}>
      <Translate i18nKey={i18nKey} values={values} formats={formats} />
    </span>
  )
}

export { Span }
